import AdminDashboard from '../../components/dashboard/AdminDashboard'

const Dashboard = () => {
  return <AdminDashboard />
}

export default Dashboard